import { Component, OnInit, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// import { Location } from '@angular/common';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
@Injectable()
export class HeaderComponent implements OnInit {

  public activeLang: string;

  constructor(
    // private location: Location,
    private translate: TranslateService
  ) {
    let userLang = navigator.language || window.navigator['userLanguage'];

    let catalan = ["ca", "ca-ES"]
    let spanish = ["es", "es-ES", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-DO", "es-EC", "es-SV", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PY", "es-PE", "es-PR", "es-UY", "es-VE"]
    let english = ["en", "en-GB", "en-US", "en-AU", "en-BZ", "en-CA", "en-IE", "en-JM", "en-NZ", "en-PH", "en-ZA", "en-TT", "en-ZW"]

    if (localStorage.getItem('language')) {
      translate.setDefaultLang(localStorage.getItem('language'));
      translate.use(localStorage.getItem('language'));
    } else {
      if (catalan.includes(userLang)) {
        userLang = "ca";
        this.activeLang = "ca";
      } else if (spanish.includes(userLang)) {
        userLang = "es";
        this.activeLang = "es";
      } else if (english.includes(userLang)) {
        userLang = "en";
        this.activeLang = "en";
      } else {
        userLang = "en";
        this.activeLang = "en";
      }
      translate.setDefaultLang(userLang);
      translate.use(userLang);
      localStorage.setItem('language', userLang);
    }
  }
  ngOnInit() {
  }

  public cambiarLenguaje(lang) {
    this.translate.setDefaultLang = lang;
    this.translate.use(lang);
    this.activeLang = lang;
    localStorage.setItem('language', lang);
    // this.location.replaceState('/'+lang);
  }

}
